import { gql } from 'apollo-angular'

import { ORGANIZATION_RESELLER_REQUEST_FIELDS } from '../../fragments/organization-reseller-request.fragment'

export const DELETE_ORGANIZATION_RESELLER_REQUEST = gql`
  mutation DeleteOrganizationResellerRequest($id: Int!) {
    deleteOrganizationResellerRequest(id: $id) {
      ...OrganizationResellerRequestFields
    }
  }
  ${ORGANIZATION_RESELLER_REQUEST_FIELDS}
`
